import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import {
  ValidCaptcha,
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaNumeroTelefono,
  validaEmail,
  validaDecimal,
  formatoDeci,
} from "../../util/varios";
import axios from "axios";
import CatalogoClaseTasas from "../../catalogos/catalogoClaseTasas";
import moment from "moment";
export const ModalTasas = (props) => {
  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          ID
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Descripción",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-alt">
          {" "}
          FECHA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-clipboard-list">
          {" "}
          TIPO MULTA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          CONCEPTO
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-money-bill-wave">
          {" "}
          MONTO
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "Código Clase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-clipboard-check">
          {" "}
          PAGADA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
  ];

  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [tipoImpuesto, setTipoImpuesto] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [municipios, setMunicipios] = useState();
  const [impuestos, setImpuestos] = useState();
  const [records, setRecords] = useState([]);
  const [petro, setPetro] = useState();
  const [ute, setUte] = useState();
  const [uc, setUc] = useState();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [values, setValues] = useState({
    codigotasa: "",
    descripcion: "",
    factorcalculo: 1,
    idtipotasa: "",
    tipoimpuesto: "",
    valor: "",
    concepto: "",
    fechatasa: "",
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const txtAlicuota = useRef();
  const txtMinimo = useRef();
  const txtId = useRef();
  const txtDescrip = useRef();
  const txtCodigo = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const chkBs = useRef();
  const chkUt = useRef();
  const cmbImuesto = useRef();
  const txtCodOr = useRef();
  const txtConcep = useRef();
  const txtFecha = useRef();
  const txtValorUni = useRef();
  const txtValorTotal = useRef();
  const txtBUscar = useRef();

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idtipotasa.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.codigotasa.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const seleccionarUte = () => {
    let endpoint = `${op.conexion}/api/valorute`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setUte(response.data[0].valor);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarPetro = () => {
    let endpoint = `${op.conexion}/api/valorpetro`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setPetro(response.data[0].valor);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarUnidadContable = () => {
    let endpoint = `${op.conexion}/api/tasas/unidadcontable`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setUc(response.data[0].valor);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/tasas/actualizartasasxagentes`;
    let body;
    setActivate(true);
    console.log(operacion);
    let nomtabla = "";
    if (props.tipoimpuesto === "1") {
      nomtabla = "mina";
    } else if (props.tipoimpuesto === "2") {
      nomtabla = "produccion";
    } else if (props.tipoimpuesto === "3") {
      nomtabla = "1x500";
    } else if (props.tipoimpuesto === "4") {
      nomtabla = "expendedores";
    }
    body = {
      operacion: operacion,
      nid: props.idTasa !== "" ? props.idTasa : 0,
      fec: txtFecha.current.value,
      idTipo: parseInt(txtId.current.value),
      descr: txtDescrip.current.value.trim(),
      conce: txtConcep.current.value,
      nmonto: txtValorTotal.current.value.replace(/\./g, "").replace(",", "."),
      idCont: props.idagente,
      tabla: nomtabla,
      tipimp: props.idTipoImpuesto,
      nanio: moment(fechaSistema).format("YYYY"),
      nmes: moment(fechaSistema).format("MM"),
    };
    console.log(body);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SeleccionarImpuestos = () => {
    setActivate(true);

    let campos = "trim(descripcion) as descripcion";
    let nomtab = "tipoimpuesto";
    let orden = "idtipoimpuesto";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setImpuestos(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChange = (event) => {
    if (
      event.target.name === "codigoclaseminas" ||
      event.target.name === "descripcion" ||
      event.target.name === "codigotasa"
    ) {
      event.target.value = event.target.value.toUpperCase();
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipoimpuesto") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "factorcalculo") {
      setValues({
        ...values,
        [event.target.name]: parseInt(event.target.value),
      });
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.which === 13) {
        if (event.target.id === "alicuotas") {
          txtAlicuota.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtId.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar un Tipo de Tasa",
        icono: "informacion",
      });
      sigue = false;
      txtBUscar.current.focus();
    } else if (txtConcep.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Concepto",
        icono: "informacion",
      });
      sigue = false;
      txtConcep.current.focus();
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const montoTotal = (factor, valuni) => {
    let total;
    console.log(petro, ute, uc);
    if (factor === 1) {
      total = parseFloat(valuni) * 1;
    } else if (factor === 2) {
      total = parseFloat(valuni) * parseFloat(petro);
    } else if (factor === 3) {
      total = parseFloat(valuni) * parseFloat(ute);
    } else if (factor === 4) {
      total = parseFloat(valuni) * parseFloat(uc);
    }
    txtValorTotal.current.value = formatMoneda(
      total.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
  };

  const informacionTasa = (id, codor, descrip, valuni, tipimp, factor) => {
    setTipoImpuesto(tipimp);
    setMostrar(false);
    txtId.current.value = id;
    txtCodOr.current.value = codor;
    txtDescrip.current.value = descrip;
    txtValorUni.current.value = formatMoneda(
      valuni.replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtFecha.current.value = moment(fechaSistema).format("YYYY-MM-DD");
    montoTotal(factor, valuni);
  };

  const blanquear = () => {
    setActivate(false);
    setValues({
      codigotasa: "",
      descripcion: "",
      factorcalculo: 1,
      idtipotasa: "",
      tipoimpuesto: "",
      valor: "",
      concepto: "",
      fechatasa: "",
    });
    setOperacion(0);
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHideRenderizar(
      props.idagente,
      moment(fechaSistema).format("YYYY-MM-DD"),
      props.idTipoImpuesto
    );
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarCatalogo = () => {
    if (!mostrar) {
      setMostrar(true);
    } else {
      setMostrar(false);
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  useEffect(() => {
    seleccionarPetro();
    seleccionarUte();
    seleccionarUnidadContable();
  }, []);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.operacion !== 1) {
          let total;
          setValues(props.tipoTasa);
          montoTotal(props.tipoTasa.factorcalculo, props.tipoTasa.valor);
          txtFecha.current.value = moment(props.tipoTasa.fechatasa).format(
            "YYYY-MM-DD"
          );
        }
        setOperacion(props.operacion);
        console.log(props.operacion);
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Incluir Tasa</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <CatalogoClaseTasas
          show={mostrar}
          onHideCancela={cerrarCatalogo}
          onHideAceptaCatClass={informacionTasa}
          tipoimpuesto={props.tipoimpuesto}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div
          className="row mx-auto d-flex justify-content-between"
          style={{ height: "auto", overflow: "auto" }}
        >
          <div className="input-group input-group-sm mb-2 col-md-4">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Código:
            </span>
            <input
              type="text"
              className="form-control"
              ref={txtId}
              aria-label="Sizing example input"
              disabled
              defaultValue={
                values
                  ? values.idtipotasa !== null
                    ? values.idtipotasa
                    : ""
                  : ""
              }
              aria-describedby="inputGroup-sizing-sm"
            />
            <button
              type="button"
              ref={txtBUscar}
              onClick={cerrarCatalogo}
              disabled={operacion === 1 ? false : true}
              className="btn btn-sm btn-success"
            >
              <i className="fas fa-search"></i>
            </button>
          </div>

          <div className="input-group input-group-sm mb-2 col-md-6">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Código Ségun Ordenanza:
            </span>
            <input
              type="text"
              className="form-control"
              ref={txtCodOr}
              disabled
              defaultValue={
                values
                  ? values.codigotasa !== null
                    ? values.codigotasa.trim()
                    : ""
                  : ""
              }
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-12">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Descripcion:
            </span>
            <input
              type="text"
              className="form-control"
              disabled
              defaultValue={
                values
                  ? values.descripcion !== null
                    ? values.descripcion.trim()
                    : ""
                  : ""
              }
              ref={txtDescrip}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-12">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Concepto:
            </span>
            <input
              type="text"
              className="form-control text-uppercase"
              require
              disabled={
                operacion === 4
                  ? true || operacion === 3
                    ? true
                    : false
                  : false
              }
              defaultValue={
                values
                  ? values.concepto !== null
                    ? values.concepto.trim()
                    : ""
                  : ""
              }
              ref={txtConcep}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-5">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Fecha:
            </span>
            <input
              type="date"
              className="form-control"
              ref={txtFecha}
              disabled
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div className="col-md-7"></div>
          <div className="col-md-2"></div>

          <div className="input-group input-group-sm mb-2 col-md-5">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Valor Unitario:
            </span>
            <input
              type="text"
              className="form-control text-right"
              ref={txtValorUni}
              disabled
              defaultValue={
                values
                  ? values.valor !== null
                    ? formatMoneda(
                        values.valor.replace(",", "").replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : "0,00"
                  : "0,00"
              }
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>

          <div className="input-group input-group-sm mb-2 col-md-5">
            <span className="input-group-text" id="inputGroup-sizing-sm">
              Valor Total:
            </span>
            <input
              type="text"
              className="form-control text-right"
              disabled
              ref={txtValorTotal}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success "
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill "
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/tasas/modalTasas.js